var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommonwealthOfNations(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#004990",
    d: "M0 24h30V0H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "m17.18 15.67.04.01.94 1.76.63 1.87-.01.03-.05.02-.02.01-.04-.01-.93-1.74-.64-1.89q0-.02.02-.03z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "m13.9 8.33-.03-.01-.94-1.74-.63-1.89.01-.03.07-.03.03.01.94 1.76.63 1.87-.01.03z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "M17.74 15.37h.03l1.21 1.6.92 1.74-.01.04-.02.01-.04.03-.04-.01-1.2-1.57-.92-1.77.01-.03z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "m13.31 8.62-1.2-1.57-.92-1.76.01-.04.06-.04.03.01 1.21 1.59.92 1.75-.01.03-.06.04z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "M18.24 14.99h.04l1.44 1.38 1.18 1.58V18l-.06.05h-.03l-1.43-1.37-1.2-1.6.01-.04z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "M12.84 9.01h-.03l-1.43-1.36-1.2-1.6.01-.04.05-.05h.04l1.44 1.38 1.18 1.59v.04z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "m18.71 14.53 1.65 1.13 1.41 1.39v.03l-.04.06h-.04l-1.62-1.12-1.43-1.4v-.04l.04-.05z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "m12.37 9.47-1.62-1.12-1.43-1.4v-.03l.04-.06h.04L11.04 8l1.41 1.38v.04l-.04.05z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "m19.07 14 1.8.87 1.62 1.15v.04l-.03.05q0 .03-.04.01l-1.78-.86-1.63-1.15v-.04l.03-.06z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "m12.01 10-1.78-.86L8.6 7.98q-.02 0 0-.03l.03-.06q0-.02.03-.01l1.8.86 1.62 1.15v.04l-.03.06q0 .02-.04 0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "M11.74 10.57 9.84 10l-1.79-.89q-.02 0-.01-.03l.02-.06Q8.07 9 8.1 9l1.91.58 1.78.88q.02 0 .01.03l-.02.05v.01q0 .03-.04.02"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "m11.56 11.18-1.96-.27-1.9-.6-.03-.03.02-.06q0-.03.03-.02l1.98.27 1.9.6.01.02-.01.07q0 .03-.04.02"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "m11.48 11.81-1.98.04-1.98-.3q-.02 0-.02-.02v-.07l.03-.03 2-.03 1.96.29q.03 0 .02.02v.07q0 .03-.03.03"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "M11.53 12.42q0 .02-.03.02l-1.94.35-2 .02-.04-.02v-.07q0-.03.02-.03l1.97-.35 1.98-.02q.03 0 .03.03z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "M11.64 13.03q0 .03-.02.04l-1.87.64-1.97.33q-.03 0-.03-.02l-.02-.06q0-.03.02-.03l1.89-.66 1.95-.32q.03 0 .03.02z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "m11.85 13.63-.01.03-1.75.93-1.9.64-.03-.02-.03-.06.02-.04 1.76-.93 1.88-.63q.02 0 .03.02z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "M18.93 9.82v-.04l1.6-1.2 1.77-.91h.03v.01l.04.06-.01.03-1.58 1.2-1.78.92-.03-.02z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "M12.15 14.18v.04l-1.58 1.19-1.78.92-.03-.01-.04-.06v-.03l1.6-1.2 1.76-.91h.04z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "M18.55 9.32v-.04l1.38-1.44 1.6-1.17h.04l.04.06v.03L20.24 8.2l-1.61 1.18h-.04z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "M12.54 14.68v.04l-1.37 1.42-1.62 1.19h-.03l-.05-.06v-.03l1.39-1.44 1.6-1.17h.03z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "M18.09 8.88v-.03l1.14-1.64 1.39-1.4h.03l.06.04v.04L19.58 7.5l-1.4 1.42h-.04z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "M13 15.12v.04l-1.13 1.61-1.4 1.42h-.04l-.05-.04v-.03l1.14-1.64 1.39-1.4h.03z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "M17.57 8.52q-.02 0-.01-.03l.87-1.8 1.15-1.6h.06l.04.03v.04l-.85 1.77-1.17 1.62q0 .02-.03 0z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "M13.52 15.48q.02 0 .01.03l-.86 1.77-1.17 1.63h-.03l-.06-.03-.01-.04.87-1.79 1.15-1.6q.02-.02.04 0z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "m17.06 8.28-.07-.03v-.03l.57-1.9.89-1.77q0-.02.03-.01l.06.02q.03.01.02.04L18 6.48l-.9 1.79z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "m14.05 15.73.04.02.02.03-.58 1.89-.89 1.78q0 .02-.03.01l-.07-.02-.01-.04.58-1.9.88-1.76q0-.03.04-.02z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "m16.49 8.07-.04.02-.06-.02-.02-.03.27-1.97.6-1.88.03-.02.07.02q.02 0 .02.03l-.27 1.95z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "m14.63 15.91.07.02q.02 0 .02.03l-.27 1.95-.6 1.9-.03.02-.07-.02q-.03 0-.02-.03l.27-1.97.6-1.88z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "m15.83 8-.07-.01q-.02 0-.03-.03l-.04-1.99.3-1.95q0-.02.03-.02h.06q.03 0 .03.03L16.15 6l-.3 1.97q0 .03-.02.02"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "m15.26 16 .07.01q.02 0 .02.03L15.4 18l-.3 1.97q0 .02-.02.02H15q-.02 0-.02-.03l-.05-1.99.3-1.95q0-.02.03-.02"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "M15.13 8q-.03 0-.03-.02l-.36-1.95-.01-1.98.02-.03h.07q.03 0 .03.02l.35 1.94.02 2-.03.02z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "M15.96 16q.02 0 .03.02l.35 1.94.02 1.99q0 .02-.03.03h-.06q-.03 0-.03-.02L15.88 18l-.01-1.97q0-.02.02-.03z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "m14.5 8.12-.03-.02-.66-1.88-.32-1.94q0-.03.02-.03l.07-.02q.02 0 .03.02l.65 1.86.33 1.96q0 .03-.02.03z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "M16.58 15.88q.03 0 .04.02l.65 1.86.33 1.96-.02.04-.07.01q-.02 0-.03-.02l-.66-1.87-.32-1.95q0-.02.02-.03z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "m12.98 12.09.56-.27.06-.03.48-.21a12 12 0 0 0 .66 1.57l-.04.02-1.04.5a6 6 0 0 1-.68-1.58"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "m15.27 12.91-.2.1q-.2-.36-.31-.67l-.37-.9.65-.29.1-.03.76-.32.01.03a15 15 0 0 1 .68 1.53z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "M17.78 11.02q.16.39.27.79l-.61.22-.14.05-.38.15a10 10 0 0 0-.7-1.56l.23-.09.3-.12.62-.24q.24.4.41.8"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "m18.7 11.61-.38.11a5 5 0 0 0-.68-1.6l.53-.17.09-.01h.03a3.5 3.5 0 0 1 .67 1.61h-.02l-.03.01-.2.05z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "M12.86 14.15a3.5 3.5 0 0 1-.72-1.6l.01-.01.05-.05h.01l.18-.11.34-.18a5 5 0 0 0 .7 1.59l-.37.21z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "M12.1 12.3q-.08-.81.24-1.6l.04-.02.32-.2-.04.18q-.1.58 0 1.23v.02l.01.05-.03.01z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "m13.67 9.98.06-.03a6 6 0 0 0 .26 1.36l-.57.26-.5.26a3.5 3.5 0 0 1 .02-1.48z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "m14.4 9.65.18-.08.06-.02.38-.16a6 6 0 0 1 .75 1.16l-.1.04-.64.27-.4.17-.08.03-.02.02-.18.07-.05.02-.18-.59a5 5 0 0 1-.15-.74z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "m15.38 9.25.28-.1q.23-.1.45-.16l.3.18q.43.3.81.82V10l-.57.2-.1.05-.46.18a8 8 0 0 0-.82-1.14z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "m16.72 8.81.05-.01q.8.3 1.37.94h-.02l-.22.06-.41.11-.02-.01-.04-.06a4 4 0 0 0-1.06-.94z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "M15.38 8.58q.54-.03 1.06.11l-.02.01-.3.08a2 2 0 0 0-.74-.2"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "m14.66 8.81-.1-.03a2 2 0 0 1 1.28.08l-.13.05-.12.04q-.22.07-.49.18l-.03-.03q-.16-.15-.41-.29"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "m14.18 8.9.1-.02q.18.01.3.1.14.08.29.24l-.45.18h-.01l-.46.21q0-.21.02-.38.05-.25.2-.33"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "M13.03 10.07q.1-.25.25-.45.22-.31.56-.53l-.04.08v.01q-.07.2-.08.5v.04z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "M13.15 9.52q-.23.3-.37.7l-.3.18q.27-.5.67-.88"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "m14.78 15.1-.26.13-.07.04a3.5 3.5 0 0 1-1.47-.95H13l.18-.11.38-.2h.01l.03.03.01.02.06.07a4 4 0 0 0 1.12.96"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "m15.37 14.8-.02.02-.13.06-.23.1-.3-.19a4 4 0 0 1-.84-.84l-.02-.04-.02-.02.75-.35.31-.15a8 8 0 0 0 .86 1.25l-.06.03z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "m16.53 14.29-.56.24-.36-.52-.42-.75.07-.03.58-.26.09-.04.76-.3a11 11 0 0 1 .4 1.42z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "m17.4 13.92-.07.03a6 6 0 0 0-.32-1.46h.02l.5-.2.11-.05.47-.18.02.08a4 4 0 0 1-.03 1.5l-.07.04z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "m18.49 13.71.06-.03q-.29.53-.72.9l.08-.1q.22-.3.35-.68h.01l.09-.04z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "M18.03 13.89a2 2 0 0 1-.8 1.04l.05-.1a2 2 0 0 0 .07-.66l.24-.1.19-.08.16-.06z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "M16.9 15.12a.4.4 0 0 1-.2 0l-.2-.07a2 2 0 0 1-.34-.3l-.02-.02-.02-.03.07-.03.22-.1.06-.02.1-.05.04-.01.5-.2v.05q.03.26 0 .45c-.03.09-.08.26-.21.33"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "M16.51 15.24a2 2 0 0 1-1.3-.14l.17-.07.08-.04.07-.03.1-.04.25-.12.12.12a2 2 0 0 0 .5.32z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "M15 15.2a3 3 0 0 0 .88.23q-.6.05-1.18-.09h.01l.18-.09.06-.03h.03z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd51d",
    d: "M18.98 11.77c.05.57-.06 1.16-.3 1.69l-.09.02-.08.03-.19.06.06-.24a4 4 0 0 0-.01-1.35v-.01l.04-.02.35-.12.04-.01.16-.05z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonwealthOfNations);
export default __webpack_public_path__ + "static/media/commonwealth-of-nations.cca647ae81d31393c02d2090b8b7aefe.svg";
export { ForwardRef as ReactComponent };